import Joyride, { type CallBackProps } from 'react-joyride';
import { joyrideLocale, joyrideStyles } from './joyrideConfig';
import { policyEditTourSteps } from './policyEditTourSteps';
import { useCompanyPolicyTour } from './useCompanyPolicyTour';

const TOUR_STORAGE_KEY = 'hr-company-policy-edit-tour-completed';

type PolicyEditTourProps = {
    run: boolean;
    onCallback: (data: {
        status?: string;
        type?: string;
        index?: number;
    }) => void;
};

export function PolicyEditTour({ run, onCallback }: PolicyEditTourProps) {
    const handleCallback = (data: CallBackProps) => {
        onCallback({ status: data.status, type: data.type, index: data.index });
    };

    return (
        <Joyride
            steps={policyEditTourSteps}
            run={run}
            continuous
            showProgress
            showSkipButton
            callback={handleCallback}
            locale={joyrideLocale}
            styles={joyrideStyles}
            scrollToFirstStep
            scrollOffset={24}
            scrollDuration={300}
        />
    );
}

export function usePolicyEditTour() {
    return useCompanyPolicyTour(TOUR_STORAGE_KEY);
}
